"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _pollerActionKeys = require("./pollerActionKeys");

var _redux = require("redux");

var _createReducer4 = _interopRequireDefault(require("../createReducer"));

var _AsyncRequest = _interopRequireDefault(require("../AsyncRequest"));

var _Poller = require("../../browser/poller/Poller");

var _createReducer2, _createReducer3;

var _default = (0, _redux.combineReducers)({
  config: _AsyncRequest.default.createReducer(_pollerActionKeys.GET_CONFIG, (0, _defineProperty2.default)({}, _pollerActionKeys.GET_CONFIG_SUCCESS, function (state, action) {
    var interval = (0, _get2.default)(action, 'payload.body.interval', _Poller.DEFAULT_POLLER_INTERVAL);

    _Poller.poller.setTimer(interval);

    return _AsyncRequest.default.setSuccess(state, action.payload.body);
  })),
  interval: (0, _createReducer4.default)(_Poller.DEFAULT_POLLER_INTERVAL, (0, _defineProperty2.default)({}, _pollerActionKeys.GET_CONFIG_SUCCESS, function (state, action) {
    return (0, _get2.default)(action, 'payload.body.interval');
  })),
  active: (0, _createReducer4.default)(_Poller.poller.isActive(), (_createReducer2 = {}, (0, _defineProperty2.default)(_createReducer2, _pollerActionKeys.GET_CONFIG_SUCCESS, function (state, action) {
    return true;
  }), (0, _defineProperty2.default)(_createReducer2, _pollerActionKeys.START_POLLING, function (state, action) {
    return true;
  }), (0, _defineProperty2.default)(_createReducer2, _pollerActionKeys.STOP_ALL_POLLING, function (state, action) {
    return false;
  }), (0, _defineProperty2.default)(_createReducer2, _pollerActionKeys.STOP_POLLING, function (state, action) {
    return _Poller.poller.isActive();
  }), _createReducer2), false),
  poller: (0, _createReducer4.default)({}, (_createReducer3 = {}, (0, _defineProperty2.default)(_createReducer3, _pollerActionKeys.START_POLLING, function (state, action) {
    var callback = action.payload;

    _Poller.poller.start(callback);

    return state;
  }), (0, _defineProperty2.default)(_createReducer3, _pollerActionKeys.STOP_POLLING, function (state, action) {
    var callbackId = action.payload;

    _Poller.poller.stop(callbackId);

    return state;
  }), (0, _defineProperty2.default)(_createReducer3, _pollerActionKeys.STOP_ALL_POLLING, function (state, action) {
    _Poller.poller.endPolling();

    return state;
  }), _createReducer3), false)
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/poller/pollerReducer.js
// module id = 5148
// module chunks = 8